export default {
	siteTitle: 'Nafnið.is',
	site: '1',

	localLibraryName: 'nafnid_is',

	vefurApiRoot: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://130.208.108.18:8800/vefur' : '//nafnid.arnastofnun.is/django/vefur',
	apiRoot: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? '//130.208.108.18:8800/vefur/api' : '//nafnid.arnastofnun.is/django/vefur/api',

	pageSize: 50,

	gaTrackingId: 'G-MVGXD34C15'
}



// WEBPACK FOOTER //
// ./src/config.js